class Server {
    static  list = [
        window.ENV.MAIN_SERVER
    ];

    // این کار برای اینه که اگر در آینده چندین سرور داشتیم و می خواستیم درصورت مشکل در سرور 1 به سرور 2 متصل بشیم از این ویژگی استفاده می کنیم
    static main = _ => {
        return Server.list[0];
    };
}

const Api = {
    INIT: `${Server.main()}/api/baseinformation/getbaseinformations`,
    MANAGEMENT_DASHBOARD: {
        BASIC_STATISTIC: `${Server.main()}/api/statistic/getdashboarddividedbyhospitalrp`,
        BASIC_STATISTIC_DAY_DETAIL: `${Server.main()}/api/statistic/getministrydashboard_devidedbyday_total`,
        HOSPITAL_INVENTORY: `${Server.main()}/api/statistic/getministrydashboard_devidedbyinventory`,
        HOSPITAL_INVENTORY_LIST: `${Server.main()}/api/statistic/getministrydashboard_searchorgetproducts`,
        HOSPITAL_INVENTORY_DAY_DETAIL_LIST: `${Server.main()}/api/statistic/getministrydashboard_devidedbyday`
    },
    USER: {
        LOGIN: `${Server.main()}/api/account/login`,
        LOGOUT: `${Server.main()}/api/account/logout`,
        CHANGE_PASSWORD: `${Server.main()}/api/account/changepassword`,
    },
    PATIENT: {
        LIST: `${Server.main()}/api/hemo/getpatientfilecodes`,
        UPDATE: `${Server.main()}/api/hemo/updatepatientfilecode`,
        UPDATE_STATE: `${Server.main()}/api/hemo/changepatientfilecodestatus`,
        DATA: `${Server.main()}/api/sectionrequest/getpatientfilecodeinfo`
    },
    ORG: {
        LIST: {
            INCOMING: `${Server.main()}/api/org/getorgproducts`,
            REQUEST: `${Server.main()}/api/org/getawaitinghospitalrequest`,
        },
        PRODUCT: {
            ADD_TO_REQUEST: `${Server.main()}/api/org/addproducttorequest`,
            REMOVE_FROM_REQUEST: `${Server.main()}/api/org/removeproductfromrequest`,
            EDIT_FROM_REQUEST: `${Server.main()}/api/org/updateorgproduct`
        }
    },
    HOSPITAL: {
        LIST: {
            INVENTORY: `${Server.main()}/api/statistic/gethospitalinventory`,
            MINI_STATISTIC: `${Server.main()}/api/statistic/getbloodbankdashboardinfo`,
            INCOMING: `${Server.main()}/api/hemo/getincomingproducts`,
            OUTGOING: `${Server.main()}/api/hemo/getoutgoingproducts`,
            INCOMING_FOR_RESERVE: `${Server.main()}/api/hemo/getincomingproductswithreserve`,
            READY: `${Server.main()}/api/hemo/gethospitalreadyproducts`,
            DESTROYED: `${Server.main()}/api/hemo/gethospitaldestroyedproducts`,
            RETURN_TO_HOSPITAL: `${Server.main()}/api/hemo/getsectionreturnproducts`,
            RETURN_TO_ORG: `${Server.main()}/api/hemo/gethospitalreturnedproductstoorg`,
            REQUEST: `${Server.main()}/api/sectionrequest/getawaitingsectionrequest`,
            RESERVE_LOGS: `${Server.main()}/api/hemo/getreservelogs`,
            RECEIVER_LIST: `${Server.main()}/api/hemo/getoutcomingreceivername`
        }
    },
    PRODUCT: {
        DATA: `${Server.main()}/api/hemo/getproductinfo`,
        INSERT: `${Server.main()}/api/hemo/insertproduct`,
        INSERT_FIRST_INVENTORY: `${Server.main()}/api/hemoadmin/insertfirstperiodinventory`,
        UPDATE: `${Server.main()}/api/hemo/updateproduct`,
        STATE_UPDATE: `${Server.main()}/api/hemo/changeproductstatus`,
        TRACK: `${Server.main()}/api/hemo/producttracking`
    },
    REQUEST: {
        ORG: {
            DATA: `${Server.main()}/api/org/gethospitalrequestbyid`,
            AWAITING_LIST: `${Server.main()}/api/org/getawaitinghospitalrequest`,
            NORM: {
                LIST: `${Server.main()}/api/Org/GetHospitalNormRequest`,
            },
            EMER: {
                LIST: `${Server.main()}/api/org/gethospitalemgrequest`,
            },
            WASH: {
                LIST: `${Server.main()}/api/org/gethospitalwashedrequest`,
            },
            IRRADIATE: {
                LIST: `${Server.main()}/api/Org/GetHospitalRadiatedRequest`,
            },
            UPDATE_STATUS: `${Server.main()}/api/org/changerequeststatus`
        },
        HOSPITAL: {
            AWAITING_LIST: `${Server.main()}/api/sectionrequest/getawaitingsectionrequest`,
            NORM: {
                LIST: `${Server.main()}/api/sectionrequest/getsectionrequest_bloodbank`,
                INSERT: `${Server.main()}/api/hospitalrequest/insertnormrequest`
            },
            ORG_NORM: {
                LIST: `${Server.main()}/api/hospitalrequest/gethospitalnormrequest_bloodbank`,
                INSERT: `${Server.main()}/api/hospitalrequest/insertnormrequest`,
                UPDATE: `${Server.main()}/api/hospitalrequest/updatenormrequest`,
                UPDATE_STATUS: `${Server.main()}/api/hospitalrequest/changerequeststatus`
            },
            ORG_EMER: {
                LIST: `${Server.main()}/api/hospitalrequest/gethospitalemgrequest_bloodbank`,
                UPDATE: `${Server.main()}/api/HospitalRequest/UpdateEmgRequest`
            },
            WASH: {
                LIST: `${Server.main()}/api/hospitalrequest/getsectionwashedrequest_bloodbank`,
                ADD_PRODUCT: `${Server.main()}/api/hemo/addproducttorequest`,
                REMOVE_PRODUCT: `${Server.main()}/api/hemo/removeproductfromrequest`
            },
            IRRADIATE: {
                LIST: `${Server.main()}/api/hospitalrequest/getsectionradiatedrequest_bloodbank`,
                ADD_PRODUCT: `${Server.main()}/api/hemo/addproducttorequest`,
                REMOVE_PRODUCT: `${Server.main()}/api/hemo/removeproductfromrequest`
            },
            DELIVER: {
                DATA: `${Server.main()}/api/hemo/printplateletinjectionform`,
                INSERT: `${Server.main()}/api/hemo/insertoutgoingproduct`,
                CANCEL: `${Server.main()}/api/hemo/canceloutgoingproduct`,
            },
            INCOMPATIBLE: {
                LIST: `${Server.main()}/api/hemo/getincompatibleproducts`,
                INSERT: `${Server.main()}/api/hemo/insertincompatibeproduct`,
                DELETE: `${Server.main()}/api/hemo/deleteincompatibleproduct`
            },
            CROSS_MATCH: {
                DATA: `${Server.main()}/api/hemo/getcrossmatchofpatientfilecode`,
                SUBMIT: `${Server.main()}/api/hemo/insertcrossmatchforsectionrequest`,
                CANCEL: `${ Server.main()}/api/hemo/cancelcrossmatchproduct`
            },
            RESERVE: {
                LIST: `${Server.main()}/api/hemo/getreserveproducts_v2`,
                INSERT: `${Server.main()}/api/hemo/reserveproduct_v2`,
                CANCEL: `${Server.main()}/api/hemo/unreserveproduct_v2`,
            },
            REQUEST_DELIVERY_PRODUCTS: {
                LIST: `${Server.main()}/api/hemo/gethospitalrequestproducts`,
                ACCEPT: `${Server.main()}/api/hemo/changehospitalrequeststatusbyhospital`,
                ACCEPT_OR_DENY_PRODUCT: `${Server.main()}/api/hemo/changeorgproductstatus`
            },
            ACCEPT: `${Server.main()}/api/sectionrequest/acceptsectionrequestv2`,
            RECEIVE: `${Server.main()}/api/sectionrequest/receivesectionrequest`,
            SEND_TO_ORG: `${Server.main()}/api/hemo/sendrequesttoorg`
        },
        SECTION: {
            CONSUMPTION_LIST: `${Server.main()}/api/sectionrequest/getpatientproductconsumption`,
            NORM: {
                LIST: `${Server.main()}/api/sectionrequest/getsectionrequest_section`,
                DATA: `${Server.main()}/api/sectionrequest/getsectionnormrequestbyid`,
                INSERT: `${Server.main()}/api/sectionrequest/insertnormrequest`,
                INFORMAL_INSERT: `${Server.main()}/api/sectionrequest/insertrequestbybloodbank`,
                UPDATE: `${Server.main()}/api/sectionrequest/updatenormrequest`
            },
            EMER: {
                LIST: `${Server.main()}/api/sectionrequest/getsectionrequest_section`,
                INSERT: `${Server.main()}/api/sectionrequest/insertemgrequest`,
                UPDATE: `${Server.main()}/api/sectionrequest/updateemgrequest`,
            },
            ORG_EMER: {
                LIST: `${Server.main()}/api/sectionrequest/gethospitalemgrequest`,
                INSERT: `${Server.main()}/api/sectionrequest/inserthospitalemgrequest`,
                UPDATE: `${Server.main()}/api/sectionrequest/updatehospitalemgrequest`
            },
            WASH: {
                LIST: `${Server.main()}/api/sectionrequest/getsectionwashedrequest_section`,
                INSERT: `${Server.main()}/api/SectionRequest/InsertWashRequest`,
                UPDATE: `${Server.main()}/api/sectionrequest/updatewashrequest`
            },
            IRRADIATE: {
                LIST: `${Server.main()}/api/sectionrequest/getsectionradiatedrequest_section`,
                INSERT: `${Server.main()}/api/sectionrequest/insertradiatedrequest`,
                UPDATE: `${Server.main()}/api/sectionrequest/updateradiatedrequest`
            }
        },
        UPDATE_STATE: `${Server.main()}/api/sectionrequest/changerequeststatus`,
        DATA: `${Server.main()}/api/sectionrequest/getsectionrequestbyid`
    },
    COMPLICATION: {
        ORG: {
            LIST: `${Server.main()}/api/org/getcomplicatedproducts`
        },
        SECTION: {
            LIST: `${Server.main()}/api/sectionrequest/getcomplicatedproducts`,
            INSERT: `${Server.main()}/api/sectionrequest/insertcomplication`,
            UPDATE: `${Server.main()}/api/sectionrequest/updatecomplication`,
            STATE_UPDATE: `${Server.main()}/api/sectionrequest/changecomplicationstatus`
        }
    },
    CONFIGURATION: {
        ROLES: {
            LIST: `${Server.main()}/api/hemoadmin/getroleswithactions`,
            ACCESS_LIST: `${Server.main()}/api/hemoadmin/getmenueswithactions`,
            INSERT: `${Server.main()}/api/hemoadmin/insertoreditrole`,
            UPDATE: `${Server.main()}/api/hemoadmin/insertoreditrole`,
        },
        HOSPITAL_POLICIES: {
            LIST: `${Server.main()}/api/hemoadmin/getproductmaintancecondition`,
            INSERT: `${Server.main()}/api/hemoadmin/insertoreditproductmaintancecondition`,
            UPDATE: `${Server.main()}/api/hemoadmin/insertoreditproductmaintancecondition`,
            DELETE: `${Server.main()}/api/hemoadmin/deleteproductmaintancecondition`
        },
        HOSPITALS: {
            LIST: `${Server.main()}/api/hemoadmin/gethospitals`,
            INSERT: `${Server.main()}/api/hemoadmin/insertorupdatehospital`,
            UPDATE: `${Server.main()}/api/hemoadmin/insertorupdatehospital`
        },
        SECTIONS: {
            LIST: `${Server.main()}/api/hemoadmin/getsections`,
            INSERT: `${Server.main()}/api/hemoadmin/insertorupdatesection`,
            UPDATE: `${Server.main()}/api/hemoadmin/insertorupdatesection`
        },
        USERS: {
            LIST: `${Server.main()}/api/hemoadmin/getusers`,
            INSERT: `${Server.main()}/api/hemoadmin/createorupdateuserwithaccess`,
            UPDATE: `${Server.main()}/api/hemoadmin/createorupdateuserwithaccess`
        },
        DOCTORS: {
            LIST: `${Server.main()}/api/hemoadmin/getdocters`,
            INSERT: `${Server.main()}/api/hemoadmin/insertoreditdocter`,
            UPDATE: `${Server.main()}/api/hemoadmin/insertoreditdocter`
        },
        ROLES_LIST: `${Server.main()}/api/hemoadmin/getroles`
    }
};

export default Api;